// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select {
	/* background: none !important; */
	background-position: 96% 5px !important;
}

.SearchResults-loadingOverlay-KT0rB {
	position: absolute;
	height: 100%;
	width: 100%;
	z-index: 2;
	background: rgba(255, 255, 255, 0.5);
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
}

.SearchResults-searchResults-QXkoU {
	position: relative;
	padding: 0px 16px 33px;
	margin-bottom: 50px;
}

.SearchResults-resultsFooter-berQA {
	padding: 20px;
	position: relative;
}

.SearchResults-listItem-JOc_L {
	width: 100%;
	padding: 0px 17px 33px;
}

.SearchResults-resultsPagination-hrPPm {
	margin-bottom: 48px;
	position: relative;
}

@media screen and (min-width: 768px) and (max-width: 1199px) {
	.SearchResults-listItem-JOc_L {
		width: 100%;
	}
}

@media screen and (max-width: 767px) {
	.SearchResults-listItem-JOc_L {
		width: 100%;
	}

	.SearchResults-searchResults-QXkoU {
		padding: 24px 7px 33px;
	}
}

.SearchResults-summaryRow-gQitW {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 12px;
	padding: 0 25px 20px 35px;
}

.SearchResults-summaryCriteria-VMTXq {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.SearchResults-summaryDatum-zru8Y {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
	font-size: 16px;
	font-weight: normal;
	color: var(--tertiary-foreground);
}

.SearchResults-summarySeparator-JEed3 {
	color: var(--secondary-oscuro);
	font-weight: 400;
}

.SearchResults-sortWrap-BjxJH {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 8px;
}

.SearchResults-sortLabel-gwFjo {
	font-size: 15px;
	font-weight: 600;
	color: var(--secondary-oscuro);
	white-space: nowrap;
}

.SearchResults-sortSelect-oPzpg {
	/* background: var(--background-primary); */
	border: 1px solid var(--secondary-oscuro);
	border-radius: 35px;
	padding: 8px 12px;
	font-size: 14px;
	font-weight: 500;
	color: var(--primary-foreground);
	cursor: pointer;
	/* min-width: 170px; */
}

.SearchResults-sortSelect-oPzpg:focus {
	outline: none;
	border-color: var(--primary-color);
}

@media screen and (max-width: 767px) {
	.SearchResults-summaryRow-gQitW {
		padding: 0 10px 20px;
	}

	.SearchResults-summaryDatum-zru8Y {
		font-size: 13px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/SearchResults/SearchResults.css"],"names":[],"mappings":"AAAA;CACC,iCAAiC;CACjC,uCAAuC;AACxC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,UAAU;CACV,oCAAoC;CACpC,OAAO;CACP,QAAQ;CACR,SAAS;CACT,MAAM;AACP;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAe;KAAf,eAAe;CACf,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;CACT,yBAAyB;AAC1B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAe;KAAf,eAAe;CACf,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,mBAAmB;CACnB,iCAAiC;AAClC;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,2CAA2C;CAC3C,yCAAyC;CACzC,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,kCAAkC;AACnC;;AAEA;CACC;EACC,oBAAoB;CACrB;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":["select {\n\t/* background: none !important; */\n\tbackground-position: 96% 5px !important;\n}\n\n.loadingOverlay {\n\tposition: absolute;\n\theight: 100%;\n\twidth: 100%;\n\tz-index: 2;\n\tbackground: rgba(255, 255, 255, 0.5);\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\ttop: 0;\n}\n\n.searchResults {\n\tposition: relative;\n\tpadding: 0px 16px 33px;\n\tmargin-bottom: 50px;\n}\n\n.resultsFooter {\n\tpadding: 20px;\n\tposition: relative;\n}\n\n.listItem {\n\twidth: 100%;\n\tpadding: 0px 17px 33px;\n}\n\n.resultsPagination {\n\tmargin-bottom: 48px;\n\tposition: relative;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1199px) {\n\t.listItem {\n\t\twidth: 100%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.listItem {\n\t\twidth: 100%;\n\t}\n\n\t.searchResults {\n\t\tpadding: 24px 7px 33px;\n\t}\n}\n\n.summaryRow {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n\tpadding: 0 25px 20px 35px;\n}\n\n.summaryCriteria {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.summaryDatum {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 12px;\n\tfont-size: 16px;\n\tfont-weight: normal;\n\tcolor: var(--tertiary-foreground);\n}\n\n.summarySeparator {\n\tcolor: var(--secondary-oscuro);\n\tfont-weight: 400;\n}\n\n.sortWrap {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.sortLabel {\n\tfont-size: 15px;\n\tfont-weight: 600;\n\tcolor: var(--secondary-oscuro);\n\twhite-space: nowrap;\n}\n\n.sortSelect {\n\t/* background: var(--background-primary); */\n\tborder: 1px solid var(--secondary-oscuro);\n\tborder-radius: 35px;\n\tpadding: 8px 12px;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: var(--primary-foreground);\n\tcursor: pointer;\n\t/* min-width: 170px; */\n}\n\n.sortSelect:focus {\n\toutline: none;\n\tborder-color: var(--primary-color);\n}\n\n@media screen and (max-width: 767px) {\n\t.summaryRow {\n\t\tpadding: 0 10px 20px;\n\t}\n\n\t.summaryDatum {\n\t\tfont-size: 13px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingOverlay": `SearchResults-loadingOverlay-KT0rB`,
	"searchResults": `SearchResults-searchResults-QXkoU`,
	"resultsFooter": `SearchResults-resultsFooter-berQA`,
	"listItem": `SearchResults-listItem-JOc_L`,
	"resultsPagination": `SearchResults-resultsPagination-hrPPm`,
	"summaryRow": `SearchResults-summaryRow-gQitW`,
	"summaryCriteria": `SearchResults-summaryCriteria-VMTXq`,
	"summaryDatum": `SearchResults-summaryDatum-zru8Y`,
	"summarySeparator": `SearchResults-summarySeparator-JEed3`,
	"sortWrap": `SearchResults-sortWrap-BjxJH`,
	"sortLabel": `SearchResults-sortLabel-gwFjo`,
	"sortSelect": `SearchResults-sortSelect-oPzpg`
};
module.exports = ___CSS_LOADER_EXPORT___;
